import { createSlice } from "@reduxjs/toolkit";

const AddressListSlice = createSlice({
    name: 'address',
    initialState: { isLoading: false, data: [], error: undefined },
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = true;
            state.error = undefined;
        },
        setSuccess: (state, action) => {
            state.data = action.payload;
            state.isLoading = false;
            state.error = undefined;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        }
    }
});


export { AddressListSlice };